import { useSuspenseQuery } from '@apollo/client/react';
import gql from 'graphql-tag';

export const findOneTagQuery = gql`
  query findOneTagQuery($filter: FilterFindOneTagInput!) {
    findOneTagQuery(filter: $filter) {
      name
      alias
    }
  }
`;

export const useFindOneTagQuery = (
  filterOptions: { filter: string | null; alias: string | string[] | null },
  options: Record<string, unknown> = {},
) => {
  const useQueryProps = useSuspenseQuery(findOneTagQuery, {
    variables: {
      filter: filterOptions?.filter,
    },
    ...options,
  });
  const { error, data } = useQueryProps;

  return {
    error,
    data,
  };
};
